import React from 'react';

const MenuManagementMenuPreviewContext = React.createContext();

export default MenuManagementMenuPreviewContext;
